<template>
  <div class="wrapper">
    <h1>The Line</h1>
    <div v-for="(d, i) in lines" :key="i" class="line">
      {{ moment(d.date, util.dateString).format("ddd") }}
      <div class="flexRow blockRow">
        <div
          class="block"
          v-for="(n, i) in d.blocks"
          :key="i"
          :style="`background-color: ${n.color};}`"
          :class="{ quota: n.quota }"
          :title="n.title"
        />
      </div>
    </div>
    <div class="flexRow completionStats">
      <div>
        Line Completion
        <h2>{{ lineCompletion.fraction }}</h2>
        <span class="fraction">{{ lineCompletion.percentage }}%</span>
      </div>
      <div>
        Block Completion
        <h2>{{ blockCompletion.fraction }}</h2>
        <span class="fraction">{{ blockCompletion.percentage }}%</span>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

import db from "../db";
import util from "../util";
import categoryUtil from "../categoryUtil";

export default {
  name: "LineView",
  props: ["categories", "days"],
  data() {
    return {
      requiredBlocks: {
        exercise: 2,
        meditation: 1,
        projects: 4,
        reading: 2,
        motivation: 1,
      },
      util: {
        dateString: util.dateString,
      },
    };
  },
  created() {
    //Load data for the previous days if it doesn't already exist
    db.getPast7Days();
    setInterval(() => {
      this.$data.now = Date.now();
    }, 60000);
  },
  computed: {
    lines() {
      return this.daySummaries;
    },
    lineCompletion() {
      const dailyQuota = Object.values(this.requiredBlocks).reduce((accumulator, val) => accumulator + val, 0);
      const total = this.daySummaries.reduce((accumulator, day) => {
        const blocksCompleted = day.blocks.reduce((accumulator, block) => accumulator + !block.quota, 0);
        return accumulator + blocksCompleted === dailyQuota ? 1 : 0;
      }, 0);
      return {
        percentage: Math.round((1000 * total) / this.daySummaries.length) / 10,
        fraction: `${total}/${this.daySummaries.length}`,
      };
    },
    blockCompletion() {
      const total = this.daySummaries.reduce((accumulator, day) => {
        return accumulator + day.blocks.reduce((accumulator, block) => accumulator + !block.quota, 0);
      }, 0);
      const dailyQuota = Object.values(this.requiredBlocks).reduce((accumulator, val) => accumulator + val, 0);
      return {
        percentage: Math.round((1000 * total) / (dailyQuota * 7)) / 10,
        fraction: `${total}/${dailyQuota * 7}`,
      };
    },
    daySummaries() {
      return Object.keys(this.days).map(day => {
        const data = Object.keys(this.requiredBlocks)
          .map(k => {
            const blocks = [];
            const category = this.getCategoryByName(k);
            const quota = this.requiredBlocks[k];
            const completed = categoryUtil.getCompleted(category.id, day, true);
            // const completed = Object.keys(this.days[day][category.id] || {}).length;
            for (let i = 0; i < quota; i++) {
              const color = util.colors[category.color];
              const opacity = i < completed ? "ff" : "30";
              blocks.push({
                //RGBA HEX FTW!
                color: color + opacity,
                title: category.name,
                quota: i >= completed,
              });
            }
            return blocks;
          })
          .flat();

        return {
          date: day,
          blocks: data,
        };
      });
    },
  },
  methods: {
    getCategoryByName(name) {
      return Object.values(this.categories).find(e => {
        return e.name.toLowerCase() == name;
      });
    },
    moment,
  },
};
</script>

<style scoped>
.wrapper {
  width: 435px;
  margin: 0 auto;
}

.line {
  margin: 0 auto;
  margin-right: 5rem;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.blockRow {
  padding: 0.25rem;
}

.quota {
  border: 1px dashed #333;
}

.completionStats {
  margin-top: 1rem;
  justify-content: space-around;
}

.completionStats h2 {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}

.fraction {
  font-size: 0.875rem;
  /* padding-right: 0.5rem; */
}
</style>



// WEBPACK FOOTER //
// LineView.vue?36edee38